import { MunicipalitySchoolsApi } from 'api';
import { useEffect, useMemo, useState } from 'react';

const municipalitySchools: { schools: { id: number; name: string }[]; loaded: boolean } = {
  schools: [],
  loaded: false,
};

const useMunicipalitySchools = () => {
  const [schools, setSchools] = useState<{ id: number; name: string }[]>(municipalitySchools.schools);
  const fetch = async () => {
    const result = await MunicipalitySchoolsApi.getMunicipalitySchoolsData();
    municipalitySchools.schools = result.data.map((el) => ({
      id: el.id,
      name: el.official_title,
    }));

    municipalitySchools.loaded = true;
    setSchools(municipalitySchools.schools);
  };
  useEffect(() => {
    if (!municipalitySchools.loaded) fetch();
  }, []);

  return useMemo(() => ({ schools, loaded: municipalitySchools.loaded }), [schools]);
};

export default useMunicipalitySchools;
